<template>
  <div class="content">
    <base-block class="mb-0" rounded title="Add Banner">
      <div class="row">
        <div class="col-md-6 form-group">
          Image
          <b-form-file
            id="file-small"
            v-model="selectedImage"
            @focus="imageEmpty = ''"
            @change="imageUpload"
          ></b-form-file>
          <div class="form-group" style="color: red" v-if="imageEmpty">
            {{ imageEmpty }}
          </div>
        </div>
      </div>
      <div class="text-center">
        <b-button
          class="text-center pt-2 pb-2 pr-4 pl-4"
          variant="success"
          style="margin-bottom: 20px"
          @click="save()"
          >Save</b-button
        >
      </div>
    </base-block>
  </div>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      selectedImage: [],
      imageEmpty: "",
    };
  },
  methods: {
    imageUpload(event) {
      this.selectedImage = event.target.files[0];
    },
    async save() {
      if (this.selectedImage == "") {
        this.imageEmpty = "Banner image is required";
        return;
      }
      const formdata = new FormData();
      formdata.append("image", this.selectedImage);
      await axios
        .post(`${this.$store.getters.baseUrl}/banner/store`, formdata, {
          headers: {
            Authorization: `Bearer ${this.$store.getters.token}`,
          },
        })
        .then((response) => {
          if (response.data.status == "success") {
            console.log(response);
            this.$swal("Success", "Banner added successfully", "success");
             this.$router.push({name: 'Tables Banners'});
            this.selectedImage = "";
            this.imageEmpty = ""
          } else {
            this.$swal("Error", response.data.message, "warning");
          }
        })
        .catch((error) => {
          console.log(error);
          this.$swal("Error", error.response.data.message, "error");
        });
    },
  },
};
</script>

